import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_einvoice_email_ocr_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface
  app_file_item_guid: fromDatatype.GuidDataFieldInterface;
  ocr_hdr_output_json: any;
  doc_reference_no: fromDatatype.VarcharArrayDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  unique_id_no: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_id_no: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_tin: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_name: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_registration_number: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_sst_id: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_msic_code: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_business_activity_desc: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_phone: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_email: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_address: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_id_no: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_tin: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_name: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_sst_id: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_address: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_phone: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_email: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_reference: fromDatatype.VarcharArrayDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  amount_payable: fromDatatype.NumericDatatypeInterface;
  amount_tax: fromDatatype.NumericDatatypeInterface;
  tax_type: fromDatatype.VarcharArrayDatatypeInterface;
  tax_rate: fromDatatype.NumericDatatypeInterface;
  einvoice_type: fromDatatype.VarcharArrayDatatypeInterface;
  einvoice_version: fromDatatype.VarcharArrayDatatypeInterface;
  einvoice_code: fromDatatype.VarcharArrayDatatypeInterface;
  ccy_code: fromDatatype.VarcharArrayDatatypeInterface;
  payment_mode: fromDatatype.VarcharArrayDatatypeInterface;
  billing_frequency: fromDatatype.VarcharArrayDatatypeInterface;
  billing_period: fromDatatype.VarcharArrayDatatypeInterface;
  digital_signature: fromDatatype.TextDatatypeInterface;
  validation_datetime: fromDatatype.TimestampTzDatatypeInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  data_source_url: fromDatatype.VarcharArrayDatatypeInterface;
  data_source_value: fromDatatype.VarcharArrayDatatypeInterface;
  data_source: fromDatatype.VarcharArrayDatatypeInterface;
  delivery_order_no: fromDatatype.VarcharArrayDatatypeInterface;
  purchase_order_no: fromDatatype.VarcharArrayDatatypeInterface;
}

export class bl_fi_einvoice_email_ocr_doc_hdr_RowClass implements bl_fi_einvoice_email_ocr_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface
  app_file_item_guid: fromDatatype.GuidDataFieldInterface;
  ocr_hdr_output_json: any;
  doc_reference_no: fromDatatype.VarcharArrayDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  unique_id_no: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_id_no: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_tin: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_name: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_registration_number: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_sst_id: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_msic_code: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_business_activity_desc: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_phone: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_email: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_address: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_id_no: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_tin: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_name: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_sst_id: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_address: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_phone: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_email: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_reference: fromDatatype.VarcharArrayDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  amount_payable: fromDatatype.NumericDatatypeInterface;
  amount_tax: fromDatatype.NumericDatatypeInterface;
  tax_type: fromDatatype.VarcharArrayDatatypeInterface;
  tax_rate: fromDatatype.NumericDatatypeInterface;
  einvoice_type: fromDatatype.VarcharArrayDatatypeInterface;
  einvoice_version: fromDatatype.VarcharArrayDatatypeInterface;
  einvoice_code: fromDatatype.VarcharArrayDatatypeInterface;
  ccy_code: fromDatatype.VarcharArrayDatatypeInterface;
  payment_mode: fromDatatype.VarcharArrayDatatypeInterface;
  billing_frequency: fromDatatype.VarcharArrayDatatypeInterface;
  billing_period: fromDatatype.VarcharArrayDatatypeInterface;
  digital_signature: fromDatatype.TextDatatypeInterface;
  validation_datetime: fromDatatype.TimestampTzDatatypeInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  data_source_url: fromDatatype.VarcharArrayDatatypeInterface;
  data_source_value: fromDatatype.VarcharArrayDatatypeInterface;
  data_source: fromDatatype.VarcharArrayDatatypeInterface;
  delivery_order_no: fromDatatype.VarcharArrayDatatypeInterface;
  purchase_order_no: fromDatatype.VarcharArrayDatatypeInterface;
}
